/** @format */

// Every language a paper can be authored or exported in
export const AVAILABLE_LANGUAGES = ["english", "cymraeg"] as const;

// A paper/export language, derived from `AVAILABLE_LANGUAGES so the list and type cannot drift.
export type ExportLanguage = (typeof AVAILABLE_LANGUAGES)[number];

// Whether the language is welsh.
export const isWelshLang = (lang: ExportLanguage): boolean => lang === "cymraeg";

// The i18n resource code for a language
export const toLangCode = (lang: ExportLanguage): "en" | "cy" => (isWelshLang(lang) ? "cy" : "en");

// The other language, used when a ticked export adds the second language paper.
export const flipLang = (lang: ExportLanguage): ExportLanguage => (isWelshLang(lang) ? "english" : "cymraeg");
